// extracted by mini-css-extract-plugin
export default {"space":"DiskSpace-space-Pgv0A TableRowCell-cell-giPrj"};